import styled, { css, keyframes } from 'styled-components';

export interface SubtitleProps {
  blue?: boolean;
  isRemoving?: boolean;
  warning?: boolean;
}

const fadeOutAndSlide = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(50px);
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(0.5rem, 1vw, 0.625rem);
`;

export const Container = styled.div<SubtitleProps>`
  width: 100%;
  border-radius: 10px;
  border-color: ${props => props.theme.colors.border_grey};
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
  
  ${({ isRemoving }) =>
    isRemoving &&
    css`
      animation: ${fadeOutAndSlide} 0.3s forwards;
    `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: clamp(1rem, 2vw, 1.875rem);
  padding-block: clamp(0.75rem, 1.5vw, 1.25rem);
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const ContainerInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: clamp(1.5rem, 3vw, 2.5rem);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem; /* Fixed the missing semicolon */
`;

export const InfoLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 1vw, 0.625rem);
`;

export const Title = styled.span`
  font-weight: 700;
  margin-top: clamp(0.75rem, 1.5vw, 1.25rem);
  color: ${props => props.theme.colors.title};
  font-size: clamp(0.875rem, 1.2vw, 1rem);
`;

export const InfoTitle = styled.span<SubtitleProps>`
  font-weight: 700;
  color: ${props => props.theme.colors.tittle};
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const Subtitle = styled.span<SubtitleProps>`
  ${({ blue }) => blue && `
      color: #2897FF;
    `}

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: clamp(80px, 15vw, 100px);
  display: inline-block;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const InfoTitleWarning = styled.span<SubtitleProps>`
  font-weight: 700;
  color: ${props => props.warning === true ? props.theme.colors.title : props.theme.colors.negative};
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const SubtitleWarning = styled.span<SubtitleProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: clamp(80px, 15vw, 100px); 
  display: inline-block;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
  
  ${({ warning }) => !warning && `
      color:rgb(255, 40, 40);
    `}
`;